'use client';

import React, { useRef } from 'react';
import type { ReactNode } from 'react';

type TenantSiteMobileMenuProps = {
  children: ReactNode;
};

const TenantSiteMobileMenu: React.FC<TenantSiteMobileMenuProps> = ({children}) => {
  const detailsRef = useRef<HTMLDetailsElement>(null);

  const closeAfterSelection = (event: React.MouseEvent<HTMLElement>) => {
    if (!(event.target as HTMLElement).closest('a, button')) return;
    detailsRef.current?.removeAttribute('open');
  };

  return (
    <details ref={detailsRef} className="mobile-menu">
      <summary aria-label="Open navigation menu">
        <span /><span /><span />
      </summary>
      <nav aria-label="Mobile navigation" onClick={closeAfterSelection}>
        {children}
      </nav>
    </details>
  );
};

export default TenantSiteMobileMenu;
